<template>
  <v-container class="px-0 py-0">
    <v-col cols=12 lg=12 class="py-0">
        <v-row v-if="user">
            <v-col md=12 lg=12 class="pa-0">
                <v-row dense>
                    <v-col cols=12>
                        <v-alert type="error" class="pa-3 subtitle-1 font-weight-medium"
                            v-if="user.status && userRequiresConfirmation">
                            Корисник мора да достави доказ о законском старатељству.
                        </v-alert>
                        <v-alert type="warning" icon="mdi-alert" class="pa-3 subtitle-1 font-weight-medium"
                            v-if="user.status && userConfirmationProvided">
                            <v-row no-gutters>
                                <v-col class="grow">Достављени документ о законском старатељству је неопходно валидирати
                                    и након тога прихватити односно одбити пријаву.</v-col>
                                <v-col class="shrink">
                                    <v-btn dark tile class="text-none body-2 mr-1" @click="downloadDocument"
                                        :loading="documentDownloading">
                                        <v-icon>mdi-download</v-icon>
                                        Преузми документ
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-alert>
                        <v-alert class="pa-3 subtitle-1 font-weight-medium" icon="mdi-information" prominent
                            v-if="user.status && !userRequiresConfirmation && !userConfirmationProvided"
                            :dark="status[user.status-1].dark" :color="status[user.status-1].color">
                            <span v-html="userStatusMessage"></span>
                        </v-alert>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols=6 xs=12 sm=6 md=4 lg=4 xl=4>
                        <p class="details-label-caption black--text">{{$t('subsidyUser.firstName')}}</p>
                        <p class="details-label">{{user.firstName}}</p>
                    </v-col>
                    <v-col cols=6 xs=12 sm=6 md=4 lg=4 xl=4>
                        <p class="details-label-caption black--text">{{$t('subsidyUser.lastName')}}</p>
                        <p class="details-label">{{user.lastName}}</p>
                    </v-col>
                    <v-col cols=6 xs=12 sm=6 md=4 lg=4 xl=4>
                        <p class="details-label-caption black--text">{{$t('subsidyUser.userType')}}</p>
                        <p class="details-label">{{$t('userTypes.' + user.type)}}</p>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols=6 xs=12 sm=6 md=4 lg=4 xl=4>
                        <p class="details-label-caption black--text">
                            {{$t('subsidyUser.uniqueIdentificationNumber')}}
                        </p>
                        <p class="details-label">{{user.uniqueIdentificationNumber}}</p>
                    </v-col>
                    <v-col cols=12 xs=12 sm=6 md=4 lg=4 xl=4 v-if="user.identificationNumber">
                        <p class="details-label-caption black--text">{{$t('subsidyUser.identificationNumber')}}</p>
                        <p class="details-label">
                            {{user.identificationNumber}}{{getUserSubtype(user.identificationNumber)}}</p>
                    </v-col>
                    <v-col cols=12 xs=12 sm=6 md=4 lg=4 xl=4>
                        <p class="details-label-caption black--text">{{$t('subsidyUser.accountNumber')}}</p>
                        <p class="details-label">
                        <pre
                            v-if="this.user.accountNumber">{{this.user.accountNumber.substring(0, 3)}}-{{this.user.accountNumber.substring(3, 16)}}-{{this.user.accountNumber.substring(16, 18)}}</pre>
                        </p>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols=12 xs=12 sm=6 md=4 lg=4 xl=4>
                        <p class="details-label-caption black--text">{{$t('subsidyUser.subsidyAmount')}}</p>
                        <p class="details-label">{{formatAmount(user.subsidyAmount)}} {{$t('subsidyUser.currencyDin')}}
                        </p>
                    </v-col>
                    <v-col cols=12 xs=12 sm=6 md=4 lg=4 xl=4>
                        <p class="details-label-caption black--text">{{$t('subsidyUser.receivedAmount')}}</p>
                        <p class="details-label">{{formatAmount(user.receivedAmount)}} {{$t('subsidyUser.currencyDin')}}
                        </p>
                    </v-col>
                    <v-col cols=12 xs=12 sm=6 md=4 lg=4 xl=4 v-if="user.sessionId">
                        <p class="details-label-caption black--text">{{$t('subsidyUser.paymentBatch')}}</p>
                        <p class="details-label">{{getSessionDetails()}} </p>
                    </v-col>
                </v-row>
                <v-row>
                  <v-col cols=12 xs=12 sm=6 md=4 lg=4 xl=4 v-if="user.userBeneficiaries">
                        <p class="details-label-caption black--text">{{$t('subsidyUser.beneficiaries')}}</p>
                        <p class="details-label">{{user.userBeneficiaries.join(', ')}}
                        </p>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols=12 xs=12 sm=6 md=4 lg=4 xl=4 v-if="user.createdComments">
                        <p class="details-label-caption black--text">{{$t('subsidyUser.createdComments')}}</p>
                        <p class="details-label">{{this.user.createdComments}}</p>
                    </v-col>
                </v-row>
                <v-row v-if="user.status === UserStatus.PENDING && user.processed === true">
                  <v-col cols=6 xs=12 sm=6 md=4 lg=4 xl=4>
                    <p class="details-label-caption black--text">{{$t('subsidyUser.registrationRejectionReason')}}</p>
                    <p class="details-label" v-if="user.errorCode === null">{{$t('subsidyUser.rejectionReason.0')}}</p>
                    <p class="details-label" v-else>{{$t('subsidyUser.rejectionReason.' + user.errorCode)}}</p>
                  </v-col>
                </v-row>
                <v-row v-if="user.sharedUserBeneficiaries && user.sharedUserBeneficiaries.length > 0 && user.sharedUserBeneficiaries[0].uniqueIdentificationNumber">
                  <v-col cols="12">
                    <span class="details-label-caption black--text">Придружена лица</span>
                    <v-expansion-panels tile flat class="my-3">
                      <v-expansion-panel v-for="(item,i) in user.sharedUserBeneficiaries" :key="i">
                        <v-expansion-panel-header color="teal lighten-5" v-if="item.uniqueIdentificationNumber">
                          {{item.uniqueIdentificationNumber}}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col cols=6 xs=12 sm=6 md=4 lg=4 xl=4>
                                <p class="details-label-caption black--text">
                                    {{$t('subsidyUser.subsidiaryUniqueIdentificationNumber')}}
                                </p>
                                <p class="details-label">{{item.uniqueIdentificationNumber}}</p>
                            </v-col>
                            <v-col cols=6 xs=12 sm=6 md=4 lg=4 xl=4 v-if="item.name">
                                <p class="details-label-caption black--text">
                                    {{$t('subsidyUser.subsidiaryName')}}
                                </p>
                                <p class="details-label">{{item.name}}</p>
                            </v-col>
                            <v-col cols=6 xs=12 sm=6 md=4 lg=4 xl=4>
                                <p class="details-label-caption black--text">
                                    {{$t('subsidyUser.subsidiaryStatus')}}
                                </p>
                                <p class="details-label" v-if="item.status">{{$t('userStatuses.' + item.status)}}</p>
                                <p class="details-label" v-else>Није се пријавио или је одбио МУП</p>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols=12 xs=12 sm=6 md=4 lg=4 xl=4 v-if="user.userBeneficiaries">
                                  <p class="details-label-caption black--text">{{$t('subsidyUser.sharedBeneficiaries')}}</p>
                                  <p class="details-label">{{item.beneficiaries.join(', ')}}</p>
                              </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn color="deep-orange" dark tile class="text-none body-2 mr-1" @click="retrieveUserData()">
                        <v-icon left>mdi-information</v-icon>Учитај информације из шифарника</v-btn>
                  </v-col>
                </v-row>
              <v-row v-if="user.status && canUpdateBeneficiary">
                <v-col>
                  <v-btn color="teal" dark tile class="text-none body-2 mr-1" @click="openActivationDialog">
                        <v-icon left>mdi-check</v-icon>
                        Ажурирај децу и активирај</v-btn>
                </v-col>
              </v-row>
                <v-row v-if="userData">
                  <v-col cols="12">
                    <v-expansion-panels tile flat>
                      <v-expansion-panel v-if="userData.userCensusData && userData.userCensusData.length > 0">
                        <v-expansion-panel-header color="teal lighten-5">
                          Подаци из МКР
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row v-for="(item, i) in userData.userCensusData" :key="i">
                            <v-col cols="4">
                              <p class="details-label-caption black--text">
                                    {{$t('subsidyUser.father')}}
                                </p>
                                <p class="details-label">{{ item.fatherName }} - {{item.fatherUniqueIdentificationNumber}}</p>
                            </v-col>
                            <v-col cols="4">
                              <p class="details-label-caption black--text">
                                    {{$t('subsidyUser.mother')}}
                                </p>
                                <p class="details-label">{{ item.motherName }} - {{item.motherUniqueIdentificationNumber}}</p>
                            </v-col>
                            <v-col cols="4">
                              <p class="details-label-caption black--text">
                                    {{$t('subsidyUser.child')}}
                                </p>
                                <p class="details-label mb-1">{{ item.childName }} - <span class="generic-link" @click="retrieveBeneficiaryData(item.childUniqueIdentificationNumber)">{{item.childUniqueIdentificationNumber}}</span></p>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel v-if="userData.userSocialData && userData.userSocialData.length > 0">
                        <v-expansion-panel-header color="teal lighten-5">
                          Подаци корисника социјалне помоћи
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row v-for="(item, i) in userData.userSocialData" :key="i">
                            <v-col cols="4">
                              <p class="details-label-caption black--text">
                                    {{$t('subsidyUser.parentUniqueIdentificationNumber')}}
                                </p>
                                <p class="details-label">{{ item.parentUniqueIdentificationNumber}}</p>
                            </v-col>
                            <v-col cols="4">
                              <p class="details-label-caption black--text">
                                    {{$t('subsidyUser.childUniqueIdentificationNumber')}}
                                </p>
                                <p class="details-label mb-1"><span class="generic-link" @click="retrieveBeneficiaryData(item.childUniqueIdentificationNumber)">{{item.childUniqueIdentificationNumber}}</span></p>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel v-if="userData.userFosterCareData && userData.userFosterCareData.length > 0">
                        <v-expansion-panel-header color="teal lighten-5">
                          Подаци о хранитељству
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row v-for="(item, i) in userData.userFosterCareData" :key="i">
                            <v-col cols="4">
                              <p class="details-label-caption black--text">
                                    {{$t('subsidyUser.parentUniqueIdentificationNumber')}}
                                </p>
                                <p class="details-label">{{ item.parentUniqueIdentificationNumber}}</p>
                            </v-col>
                            <v-col cols="4">
                              <p class="details-label-caption black--text">
                                    {{$t('subsidyUser.childUniqueIdentificationNumber')}}
                                </p>
                                <p class="details-label mb-1"><span class="generic-link" @click="retrieveBeneficiaryData(item.childUniqueIdentificationNumber)">{{item.childUniqueIdentificationNumber}}</span></p>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
                <v-row v-if="beneficiary">
                  <v-col cols=12>
                    <v-expansion-panels tile flat>
                      <v-expansion-panel v-for="(item,i) in beneficiary" :key="i">
                        <v-expansion-panel-header color="blue-grey lighten-4" class="details-label-caption black--text" v-if="item.uniqueIdentificationNumber">
                          {{item.uniqueIdentificationNumber}} за дете {{item.beneficiaries}}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col cols=6 xs=12 sm=6 md=4 lg=3 xl=3>
                                <p class="details-label-caption black--text">
                                    {{$t('subsidyUser.uniqueIdentificationNumber')}}
                                </p>
                                <p class="details-label">{{item.uniqueIdentificationNumber}}</p>
                            </v-col>
                            <v-col cols=6 xs=12 sm=6 md=4 lg=3 xl=3>
                                <p class="details-label-caption black--text">
                                    {{$t('subsidy.userName')}}
                                </p>
                                <p class="details-label">{{item.firstName}} {{item.lastName}}</p>
                            </v-col>
                            <v-col cols=6 xs=12 sm=6 md=4 lg=3 xl=3>
                                <p class="details-label-caption black--text">
                                    {{$t('subsidy.userStatus')}}
                                </p>
                                <p class="details-label" v-if="item.status">{{$t('userStatuses.' + item.status)}}</p>
                                <p class="details-label" v-else>Није се пријавио или је одбио МУП</p>
                            </v-col>
                            <v-col cols=6 xs=12 sm=6 md=4 lg=3 xl=3>
                              <p class="details-label-caption black--text">{{$t('subsidyUser.userType')}}</p>
                              <p class="details-label">{{$t('userTypes.' + item.type)}}</p>
                          </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row v-if="canRejectSubsidy">
            <v-col cols="12">
                <v-card-actions>
                    <v-btn color="teal" dark tile class="text-none body-2 mr-1" @click="acceptDialog = true">
                        <v-icon left>mdi-check</v-icon>
                        {{$t('subsidy.acceptSubsidy')}}</v-btn>
                    <v-btn color="warning" dark tile class="text-none body-2 mr-1" @click="rejectDialog = true">
                        <v-icon left>mdi-alert</v-icon>
                        {{$t('subsidy.rejectSubsidy')}}</v-btn>
                    <v-btn color="error" dark tile class="text-none body-2 mr-1" @click="deleteDialog = true">
                        <v-icon left>mdi-alert</v-icon>
                        {{$t('subsidy.deleteDocument')}}</v-btn>
                </v-card-actions>
            </v-col>
        </v-row>
    </v-col>
    <v-dialog v-model="rejectDialog" width="550" persistent>
        <v-card tile flat class="pa-2" color="blue-grey lighten-5">
            <v-card-text class="py-2 px-2">
                <v-row dense>
                    <v-col cols="12">
                        <v-alert color="error" icon="mdi-alert" text class="rounded-0 mx-0 mb-2">
                            {{$t('subsidy.rejectSubsidyText')}}
                        </v-alert>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-textarea outlined label="Разлог одбијања" v-model="rejectionComments">item</v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn v-if="rejectionComments" color="teal" dark tile class="text-none body-2 mr-1"
                    @click="rejectSubsidy">
                    <v-icon left>mdi-check</v-icon>
                    {{$t('form.apply')}}</v-btn>
                <v-btn color="blue-grey lighten-3" tile class="text-none body-2 mr-1" @click="rejectDialog = false">
                    <v-icon left>mdi-alert</v-icon>
                    {{$t('form.cancel')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="acceptDialog" width="550" persistent>
        <v-card tile flat class="pa-2" color="blue-grey lighten-5">
            <v-card-text class="py-2 px-2">
                <v-row dense>
                    <v-col cols="12">
                        <v-alert color="success" icon="mdi-alert" text class="rounded-0 mx-0 mb-2">
                            {{$t('subsidy.acceptSubsidyText')}}
                        </v-alert>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-textarea outlined label="Разлог прихватања" v-model="acceptanceComments"></v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn color="teal" dark tile class="text-none body-2 mr-1" @click="acceptSubsidy">
                    <v-icon left>mdi-check</v-icon>
                    {{$t('form.apply')}}</v-btn>
                <v-btn color="blue-grey lighten-3" tile class="text-none body-2 mr-1" @click="acceptDialog = false">
                    <v-icon left>mdi-alert</v-icon>
                    {{$t('form.cancel')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" width="550" persistent>
        <v-card tile flat class="pa-2" color="blue-grey lighten-5">
            <v-card-text class="py-2 px-2">
                <v-row dense>
                    <v-col cols="12">
                        <v-alert color="error" icon="mdi-alert" text class="rounded-0 mx-0 mb-2">
                            {{$t('subsidy.deleteDocumentText')}}
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn color="teal" dark tile class="text-none body-2 mr-1" @click="deleteDocument">
                    <v-icon left>mdi-check</v-icon>
                    {{$t('form.apply')}}</v-btn>
                <v-btn color="blue-grey lighten-3" tile class="text-none body-2 mr-1" @click="deleteDialog = false">
                    <v-icon left>mdi-alert</v-icon>
                    {{$t('form.cancel')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="activateDialog" width="550" persistent>
        <v-card tile flat class="pa-2" color="blue-grey lighten-5">
            <v-card-text class="py-2 px-2">
                <v-row dense>
                    <v-col cols="12">
                        <v-alert color="success" icon="mdi-alert" text class="rounded-0 mx-0 mb-2">
                            {{$t('subsidy.updateBeneficiaryText')}}
                        </v-alert>
                    </v-col>
                </v-row>
                <v-row dense v-for="(item,i) in user.userBeneficiaries" :key="i">
                  <v-col>
                    {{item}}
                    <v-btn color="red" text @click="removeBeneficiary(item, i)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col><v-text-field v-model="beneficiaryItem"></v-text-field></v-col>
                  <v-col>
                    <v-btn color="success" text @click="addBeneficiary()">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn color="teal" dark tile class="text-none body-2 mr-1" @click="activate">
                    <v-icon left>mdi-check</v-icon>
                    {{$t('form.apply')}}</v-btn>
                <v-btn color="blue-grey lighten-3" tile class="text-none body-2 mr-1" @click="activateDialog = false">
                    <v-icon left>mdi-alert</v-icon>
                    {{$t('form.cancel')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue'
import { hasUserUpdateClaim } from '@/router/auth.js'
import FileSaver from 'file-saver'
import { EventBus } from '@/router/bus'

export default {
  name: 'subsidy-user-details',
  props: {
    subsidyUser: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      pageLoader: false,
      documentDownloading: false,
      rejectDialog: false,
      acceptDialog: false,
      deleteDialog: false,
      activateDialog: false,
      userId: '',
      user: null,
      userData: null,
      beneficiary: null,
      accountEditMode: false,
      statusEditMode: false,
      beneficiaryItem: '',
      UserStatus: {
        PENDING: 1,
        ACTIVE: 2,
        WAITING_ACCOUNT: 3,
        PROCESSED: 4,
        COMPLETED: 5,
        REJECTED: 6,
        ERROR: 7,
        BLOCKED: 8,
        TEMP_BLOCKED: 8,
        REQUIRES_CONFIRMATION: 101,
        CONFIRMATION_PROVIDED: 102
      },
      status: [
        {
          color: '#CFD8DC',
          dark: false,
          text: this.$t('subsidyUser.subsidyPending')
        },
        {
          color: '#52c0a8',
          dark: true,
          text: this.$t('subsidyUser.subsidyActive')
        },
        {
          color: '#52c0a8',
          dark: true,
          text: this.$t('subsidyUser.subsidyWaitingAccount')
        },
        {
          color: '#52c0a8',
          dark: true,
          text: this.$t('subsidyUser.subsidyProcessed')
        },
        {
          color: '#3d92b6',
          dark: true,
          text: this.$t('subsidyUser.subsidyCompleted')
        },
        {
          color: '#FF5722',
          dark: true,
          text: this.$t('subsidyUser.subsidyRejected')
        },
        {
          color: '#d3454a',
          dark: true,
          text: this.$t('subsidyUser.subsidyError')
        },
        {
          color: '#ffac81',
          dark: false,
          text: this.$t('subsidyUser.subsidyRejected')
        },
        {
          color: '#ffac81',
          dark: false,
          text: this.$t('subsidyUser.subsidyRejected')
        }
      ],
      uniqueIdentificationNumberMask: '#############',
      accountNumberFirstPartyMask: '###',
      accountNumberMiddlePartyMask: '#############',
      accountNumberLastPartyMask: '##',
      retrieveUser: {
        identificationNumber: null,
        uniqueIdentificationNumber: null
      },
      updateUser: {
        uniqueIdentificationNumber: '',
        rejectionComments: ''
      },
      rejectionComments: null,
      acceptanceComments: null
    }
  },
  watch: {
    subsidyUser: {
      handler: function (user) {
        this.user = user
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    uniqueIdentificationNumberErrors () {
      return this.getRetrieveValidationErrorsByName('uniqueIdentificationNumber')
    },
    userStatusMessage () {
      return this.formatOperatorUserStatus(this.user, this.UserStatus)
    },
    canUpdateUser () {
      return hasUserUpdateClaim()
    },
    userRequiresConfirmation () {
      if (!this.user) { return false }

      return this.user.status === this.UserStatus.REQUIRES_CONFIRMATION
    },
    userConfirmationProvided () {
      if (!this.user) { return false }

      return this.user.status === this.UserStatus.CONFIRMATION_PROVIDED
    },
    canRejectSubsidy () {
      if (!this.user) { return false }

      return this.user.status === this.UserStatus.CONFIRMATION_PROVIDED && hasUserUpdateClaim()
    },
    canUpdateBeneficiary () {
      if (!this.user) { return false }

      return this.user.status !== this.UserStatus.PROCESSED && this.user.status !== this.UserStatus.ACTIVE && this.user.status !== this.UserStatus.WAITING_ACCOUNT
    }
  },
  methods: {
    initUser (newValue) {
      this.user = newValue
    },
    getRetrieveValidationErrorsByName (name) {
      if (!this.$v.retrieveUser[name].$dirty) return []
      return this.getValidationErrors('retrieveUser').filter((x) => { return x.field === name }).map(x => x.msg)
    },
    getAccountValidationErrorsByName (name) {
      if (!this.$v.registerAccount[name].$dirty) return []
      return this.getValidationErrors('registerAccount').filter((x) => { return x.field === name }).map(x => x.msg)
    },
    getUpdateValidationErrorsByName (name) {
      if (!this.$v.updateUser[name].$dirty) return []
      return this.getValidationErrors('updateUser').filter((x) => { return x.field === name }).map(x => x.msg)
    },
    validateBeforeRetrieve () {
      this.$v.retrieveUser.$touch()
      if (this.$v.retrieveUser.$invalid) {
        this.$nextTick(function () {
          document.body.scrollTop = 0
        })
        return
      }
      this.submitRetrieval()
    },
    openActivationDialog () {
      this.activateDialog = true
    },
    activate () {
      this.activateDialog = false
      if (this.beneficiaryItem) {
        this.user.userBeneficiaries.push(this.beneficiaryItem)
      }
      EventBus.$emit('page-loader', true)
      this.$http.put(Vue.$apiConfig.updateBeneficiariesPut.replace('{uniqueIdentificationNumber}', this.user.uniqueIdentificationNumber), this.user.userBeneficiaries).then(
        response => {
          this.logConsole(response)
          this.user = response.data.payload
          EventBus.$emit('page-loader', false)
        },
        error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          EventBus.$emit('page-loader', false)
        })
    },
    removeBeneficiary (item, i) {
      this.user.userBeneficiaries.splice(i, 1)
    },
    addBeneficiary () {
      this.user.userBeneficiaries.push(this.beneficiaryItem)
      this.beneficiaryItem = ''
    },
    submitRetrieval () {
      this.user = null
      EventBus.$emit('page-loader', true)
      this.userId = this.retrieveUser.uniqueIdentificationNumber
      this.$http.get(Vue.$apiConfig.userGet, { params: { uniqueIdentificationNumber: this.userId } }).then(
        response => {
          this.logConsole(response)
          this.user = response.data.payload
          this.crearRetrieveData()
          EventBus.$emit('page-loader', false)
        },
        error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          EventBus.$emit('page-loader', false)
        })
    },
    retrieveUserData () {
      this.userData = null
      EventBus.$emit('page-loader', true)
      this.$http.get(`${Vue.$apiConfig.userDataGet}/${this.user.uniqueIdentificationNumber}`).then(
        response => {
          this.logConsole(response)
          this.userData = response.data.payload
          EventBus.$emit('page-loader', false)
          if ((this.userData.userCensusData && this.userData.userCensusData.length === 0) &&
            (this.userData.userSocialData && this.userData.userSocialData.length === 0) &&
            (this.userData.userFosterCareData && this.userData.userFosterCareData.length === 0)) {
            EventBus.$emit('alert', {
              variant: 'error',
              message: 'Нема података о захтеваном кориснику'
            })
          }
        },
        error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          EventBus.$emit('page-loader', false)
        })
    },
    retrieveBeneficiaryData (uniqueIdentificationNumber) {
      this.beneficiary = null
      EventBus.$emit('page-loader', true)
      this.$http.get(`${Vue.$apiConfig.beneficiaryDataGet}/${uniqueIdentificationNumber}`).then(
        response => {
          this.logConsole(response)
          this.beneficiary = response.data.payload
          EventBus.$emit('page-loader', false)
        },
        error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          EventBus.$emit('page-loader', false)
        })
    },
    submitRetrievalById () {
      this.user = null
      EventBus.$emit('page-loader', true)
      this.userId = this.retrieveUser.identificationNumber
      this.$http.get(Vue.$apiConfig.userGet + '/' + this.userId).then(
        response => {
          this.logConsole(response)
          this.user = response.data.payload
          this.crearRetrieveData()
          EventBus.$emit('page-loader', false)
        },
        error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          EventBus.$emit('page-loader', false)
        })
    },
    crearRetrieveData () {
      this.retrieveUser.uniqueIdentificationNumber = ''
      this.$v.retrieveUser.$reset()
    },
    getSessionDetails () {
      const bank = this.user.sessionId.substring(0, 3)
      const session = this.user.sessionId.substring(3, 5)
      const output = this.formatFlatDate(this.user.sessionId.substring(5)) + ', ' + 'пресек ' + session + ', '
      if (bank === Vue.$config.treasuryBank) {
        return output + 'Платни промет УТ'
      } else {
        return output + this.getBankName(bank)
      }
    },
    downloadDocument (documentId) {
      this.documentDownloading = true
      this.$http.get(`${Vue.$config.dms_root_internal}/${Vue.$apiConfig.uploadDocumentGet}/${this.user.identificationNumber}`, { responseType: 'blob' })
        .then(response => {
          this.documentDownloading = false
          var headers = response.headers
          var blob = new Blob([response.data], { type: headers['content-type'] })
          FileSaver.saveAs(blob, `${this.user.identificationNumber} - ${this.formatDate(new Date())}.pdf`)
        },
        error => {
          this.documentDownloading = false
          this.logConsole(error)
          this.formatErrorResponse(error)
        })
    },
    deleteDocument () {
      this.deleteDialog = false
      EventBus.$emit('page-loader', true)
      this.$http.delete(`${Vue.$config.dms_root_internal}/${Vue.$apiConfig.uploadDocumentGet}/${this.user.identificationNumber}`)
        .then(response => {
          EventBus.$emit('page-loader', false)
          this.user = response.data.payload
        },
        error => {
          EventBus.$emit('page-loader', false)
          this.logConsole(error)
          this.formatErrorResponse(error)
        })
    },
    rejectSubsidy () {
      this.rejectDialog = false
      EventBus.$emit('page-loader', true)
      const rejectionUser = {
        identificationNumber: this.user.identificationNumber,
        rejectionComments: this.rejectionComments
      }
      this.$http.post(Vue.$apiConfig.rejectUserStatusPost, rejectionUser).then(
        response => {
          this.logConsole(response)
          this.user = response.data.payload
          this.rejectionComments = null
          EventBus.$emit('page-loader', false)
        },
        error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          EventBus.$emit('page-loader', false)
        })
    },
    acceptSubsidy () {
      this.acceptDialog = false
      EventBus.$emit('page-loader', true)
      const acceptanceUser = {
        identificationNumber: this.user.identificationNumber,
        acceptanceComments: this.acceptanceComments
      }
      this.$http.post(Vue.$apiConfig.acceptUserStatusPost, acceptanceUser).then(
        response => {
          this.logConsole(response)
          this.user = response.data.payload
          this.acceptanceComments = null
          EventBus.$emit('page-loader', false)
        },
        error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          EventBus.$emit('page-loader', false)
        })
    }
  }
}
</script>

<style scoped>
  .v-card__text {
    font-size: 15px
  }
  .user-info-type {
    font-size: 16px
  }
  .user-info {
    font-size: 16px;
    font-weight: 600
  }
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }

  .role-popout {
    background-color: #E0F2F1 !important;
  }

  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .centered-label {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
</style>
